import _ from 'lodash';

export const extendCustomUserFields = (customUserFields) => {
  customUserFields.forEach((field) => {

    if (field.type === 'bool') {
      const value = _.get(field, ['metadata', 'default']);
      field.defaultValue = _.isBoolean(value);
      field.required = false;
    }

    if (field.type === 'select') {
      const choices = _.get(field, ['metadata', 'choices']);
      if (_.isArray(choices)) {
        let defaultChoiceIndex = _.findIndex(choices, (choice) => choice.default === true);

        if (defaultChoiceIndex != -1) {
          choices.splice(0, 0, choices.splice(defaultChoiceIndex, 1)[0]);
        } else {
          const placeholder = setPlaceholder(field);
          defaultChoiceIndex = _.findIndex(choices, (choice) => choice.value === 'placeholder');
          if (defaultChoiceIndex != -1) {
            choices[defaultChoiceIndex].title = placeholder;
            choices.splice(0, 0, choices.splice(defaultChoiceIndex, 1)[0]);
          } else {
            choices.unshift({value: 'placeholder', title: placeholder});
          }
        }
        field.metadata.choices = choices;
      }
    }

    let value = null;
    if ("defaultValue" in field) {
      value = field.defaultValue;
    }
    if (field.type === 'select') {
      value = field.metadata.choices[0]
    }

    field.defaultValue = value;
    field.identity = 'custom_fields';
  })
  return customUserFields;
}



export const setPlaceholder = (customUserField) => {
  let placeholder = _.get(customUserField, ['metadata', 'placeholder'], _.get(customUserField, 'name', ''));
  return placeholder;
}
